import { BoxIRemoteApi } from "./api.box";
import { CloudIRemoteApi } from "./api.cloud";
import { getService } from "@cems-eco/core/src/utils/platform";
import { BaseIRemoteApi } from "./api.base";
import environment from "@/config";

export default getService<BaseIRemoteApi>(environment.nexus, {
    box: new BoxIRemoteApi(),
    cloud: new CloudIRemoteApi(),
});